import * as React from 'react';
import { useContext } from 'react';

import LocalizationContext from '../../contexts/Localizations';
import { HeroBanner } from '../common';
import { ContentHeroProps } from './type';
import './styles.scss';

const ContentHero = ({
  backLink,
  colorTheme = 'blue',
  image,
  isLanding,
  isForPage,
  links,
  linksHeading,
  summary,
  title,
  titlePrefix,
  disableUppercase,
}: ContentHeroProps) => {
  const { translations } = useContext(LocalizationContext);

  const root = 'content-hero';
  const classes = [
    root,
    `${root}--theme-${colorTheme}`,
  ];
  if (isLanding) {
    classes.push(`${root}--landing`);
  }
  if (titlePrefix) {
    classes.push(`${root}--with-prefix`);
  }
  // A page that has the "FOR"  prefix in the title, ex: https://www.uci.org/for-federations/28BogNv1Y3vtxJPkq7vgFs
  if (isForPage) {
    classes.push(`${root}--is-for-page`);
  }

  const titleWordSplit = title.toLowerCase().split('for ');
  const adjustedTitle = isForPage ? title.toLowerCase().split('for ')[titleWordSplit.length - 1] : title;

  return (
    <HeroBanner
      backLink={backLink}
      colorTheme={colorTheme}
      image={image}
      imageSize="half"
      isDarkened={false}
      isLanding={isLanding}
      isForPage={isForPage}
    >
      <header className={classes.join(' ')}>
        {isLanding && titlePrefix && (
          <p className={`${root}__title_prefix`}>
            {titlePrefix}
          </p>
        )}

        <h1
          className={`${root}__title ${isForPage ? `${root}__title--with-for-prefix` : ''}
            ${disableUppercase ? `${root}__title--disable-uppercase` : ''}`}
          data-for-label={translations.header.forLabel}
        >
          {adjustedTitle}
        </h1>

        {summary && <p className={`${root}__summary`}>{summary}</p>}

        {linksHeading && (<h2 className={`${root}__links-heading`}>{linksHeading}</h2>)}

        {links && (
          <ul className={`${root}__links`}>
            {links.map((link) => (
              <li key={link.url}>
                <a href={link.url}>
                  {link.title}
                </a>
              </li>
            ))}
          </ul>
        )}
      </header>
    </HeroBanner>
  );
};

export default ContentHero;
